<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">การนำสินค้าเข้าคลัง</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
          <div class="title_page ma-3">
            <!-- <v-btn v-if="storeDetail.status_main_store == 1" type="button" class="btn_add_data" elevation="4" @click="link('/arin/pos/inventoryadd')"
              large>เพิ่มสินค้าเข้าคลัง</v-btn> -->
            <v-btn
              type="button"
              class="btn_add_data"
              elevation="4"
              @click="link('/arin/pos/inventoryadd')"
              large
              >เพิ่มสินค้าเข้าคลัง</v-btn
            >
          </div>
        </v-col>
      </v-row>

      <v-card elevation="4">
        <v-card-text>
          <v-row>
            <v-col xs="12" sm="6" md="8" lg="8" xl="8" cols="12">
              <v-card-title style="color: #000"
                >ประวัติการนำสินค้าเข้าคลัง</v-card-title
              >
              <v-btn
                elevation="2"
                class="my-3 mx-1 font-16 py-5"
                outlined
                color="#88B358"
                title="Export ข.ย.9"
                style="border-radius: 10px"
                @click="openExport = true"
              >
                <img
                  src="@/assets/arin_assets/excel-icon.png"
                  alt="excel icon"
                  class="mr-2"
                />
                Export ข.ย.9
              </v-btn>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="4" xl="4" cols="12">
              <v-text-field
                color="#D6BFAF"
                class="input-radius"
                append-icon="mdi-magnify"
                hide-details="auto"
                required
                v-model="search"
                placeholder="ค้นหา..."
                single-line
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
              <v-data-table
                :headers="headers"
                :items="data_list"
                :search="search"
                :footer-props="footer_Props"
                mobile-breakpoint="0"
              >
                <template v-slot:item="dataDetail">
                  <tr>
                    <td>
                      <div>{{ dataDetail.item.receipt_no }}</div>
                    </td>
                    <td>
                      <div>{{ dataDetail.item.receipt_date }}</div>
                    </td>
                    <td>
                      <div>
                        {{
                          dataDetail.item.supplier_name != null
                            ? dataDetail.item.supplier_name
                            : "-"
                        }}
                      </div>
                    </td>
                    <td>
                      <div>
                        {{
                          dataDetail.item.import_type == 0
                            ? "ใบสั่งซื้อ"
                            : dataDetail.item.import_type == 1
                            ? "ใบเสร็จ"
                            : "-"
                        }}
                      </div>
                    </td>
                    <td>
                      <div>{{ formatPrice(dataDetail.item.total) }}</div>
                    </td>
                    <td>
                      <div>{{ dataDetail.item.user_name }}</div>
                    </td>
                    <td>
                      <div class="pa-3">
                        <v-btn
                          elevation="4"
                          class="ma-2"
                          outlined
                          color="#8EBBDC"
                          title="ดูรายละเอียด"
                          @click="
                            link(
                              '/arin/pos/historyimportinventorydetail/' +
                                dataDetail.item.id
                            )
                          "
                          style="border-radius: 10px"
                        >
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn
                          v-if="dataDetail.item.import_type == 0"
                          elevation="4"
                          class="ma-2"
                          outlined
                          color="#FEA06C"
                          title="แก้ไขรายละเอียด"
                          @click="
                            link(
                              '/arin/pos/inventoryedit/' + dataDetail.item.id
                            )
                          "
                          style="border-radius: 10px"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
    <!-- modal export excel -->
    <v-dialog v-model="openExport" persistent max-width="600">
      <v-card class="input-radius">
        <div class="d-flex justify-space-between">
          <v-card-title> Export ข.ย.9 </v-card-title>
          <v-btn icon class="ma-4" @click="openExport = false">
            <v-icon color="grey">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-row class="my-8">
            <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
              <!-- เดือน -->
              <v-select
                color="#86bc3a"
                @input="get_data()"
                :items="month_arr"
                item-text="month_name"
                item-value="month_number"
                v-model="selected_month_member"
                prepend-inner-icon="mdi-calendar-month-outline"
                label="เดือน"
                hide-details="auto"
                outlined
              ></v-select>
            </v-col>
            <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
              <v-select
                color="#86bc3a"
                @input="get_data()"
                :items="year_arr"
                item-text="year_eng"
                item-value="year_eng"
                v-model="selected_year_member"
                prepend-inner-icon="mdi-calendar-month-outline"
                label="ปี ค.ศ."
                hide-details="auto"
                outlined
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pb-5 flex">
          <v-spacer></v-spacer>
          <v-btn
            type="button"
            class="btn_add_data export-file"
            elevation="4"
            @click="exportToExcel()"
            large
            >Export</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";
import * as XLSX from "xlsx-js-style";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_history_import",
  data() {
    return {
      loading_page: false,
      page: 1,
      size: 10,
      search: "",
      openExport: false,
      selected_year_member: null,
      selected_month_member: null,
      year_arr: [],
      month_arr: [],
      footer_Props: {
        "items-per-page-text": "รายการต่อหน้า",
      },
      sub_menu: [
        { text: "ระบบ POS", disabled: false },
        { text: "คลังสินค้า", disabled: false },
        { text: "การนำสินค้าเข้าคลัง", disabled: false, href: "#" },
      ],
      headers: [
        { text: "เลขที่ใบเสร็จ", value: "receipt_no", fixed: true, width: "150px", align: "left" },
        { text: "วันที่", value: "receipt_date", fixed: true, width: "140px" },
        { text: "ชื่อบริษัท", value: "supplier_name", fixed: true, width: "370px" },
        { text: "การนำเข้า", value: "import_type", fixed: true, width: "160px" },
        { text: "ยอดซื้อ", value: "total", fixed: true, width: "180px" },
        { text: "ผู้จัดทำ", value: "user_name", fixed: true, width: "200px" },
        { text: "จัดการ", value: "", fixed: true, sortable: false, width: "200px" },
      ],
      data_list: [],
      storeDetail: {},
      data_excel: [],
      jsonExcel: [],
      date_universal: this.dateExport(),
    };
  },
  methods: {
    link(link) {
      window.location.href = link;
    },
    formatPrice(number) {
      return formatPrice(number);
    },
      // ฟังก์ชันสำหรับสร้างตัวเลือกปี
    year_function() {
      this.year_arr = [];
      let arr_year = [0, 1, 2];
      let count_year = new Date();
      let full_year = count_year.getFullYear();

      for (let i = 0; i < arr_year.length; i++) {
        let count_th = full_year + 543 - i;
        let count_eng = full_year - i;
        this.year_arr.push({
          id: i,
          year_th: count_th,
          year_eng: count_eng,
          show_year: "ปี " + count_th,
        });
      }

      this.selected_year_member = this.year_arr[0].year_eng;
    },

  // ฟังก์ชันสำหรับสร้างตัวเลือกเดือนตามปีที่เลือก
  month_function(selected_year) {
    this.month_arr = [];
    let count_year = new Date();
    let current_year = count_year.getFullYear();
    let current_month = count_year.getMonth() + 1;

    let months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

    if (selected_year === current_year) {
      months = months.filter((month) => month <= current_month);
    }

    const monthFormatter = new Intl.DateTimeFormat("th-TH", {
      month: "long",
    });

    months.forEach((month, index) => {
        const date = new Date(selected_year, month - 1);
        this.month_arr.push({
          id: index,
          month_number: month,
          month_name: monthFormatter.format(date),
        });
      });

      this.selected_month_member = this.month_arr[0].month_number;
    },

    getInventory() {
      this.loading_page = true;
      this.data_list = [];
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/pos/import", config).then((res) => {
        if (res.data.successful === true) {
          this.data_list = res.data.import_list;
        }
        this.loading_page = false;
      });
    },
    getShow_api() {
      let store_id = this.$store.state.store_arin.user_data.store_id;
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/stores/detail/" + store_id, config).then((res) => {
        if (res.data.successful === true) {
          this.storeDetail = res.data.storeDetail;
          this.loading_page = false;
        }
      });
    },


    exportToExcel() {
      // เรียก API ตอนกดปุ่ม Export
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };

      // เรียก API เพื่อดึงข้อมูล
      HTTP_ARIN.get(`/pos/importexcel?month=${this.selected_month_member}&year=${this.selected_year_member}`, config)
        .then((res) => {
          if (res.data.successful) {
            const importList = res.data.data.import_list;
            
            // ยัดข้อมูลจาก API ลงใน data_excel
            this.data_excel = importList.map((item, index) => {
           
            // --- ส่วนของ create_import ---
            let formattedDate = '-'; // กำหนดค่าเริ่มต้น
            if (item.create_import) { // ตรวจสอบว่า item.create_import ไม่ใช่ null
                let dateParts = item.create_import.split(' ')[0].split('-');
                formattedDate = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
            }

            // --- ส่วนของ date_expired ---
            let formattedDateExp = '-'; // กำหนดค่าเริ่มต้น
            if (item.date_expired) { // ตรวจสอบว่า item.date_expired ไม่ใช่ null
                let dateExp = item.date_expired.split(' ')[0].split('-');
                formattedDateExp = `${dateExp[2]}/${dateExp[1]}/${dateExp[0]}`;
            }

            return {
              no: index + 1, // กำหนดลำดับ
              date: formattedDate, // วันที่ที่ถูกจัดรูปแบบ
              loca: item.supplier_name, // ชื่อบริษัท
              description: item.product_name, // ชื่อสินค้า
              lotNo: item.lot_no, // เลข lot no.
              amount: item.quantity, // จำนวนสินค้า
              unit: item.unit_name, // หน่วยสินค้า
              discountAmount: item.discount_amount == null ? 0 : item.discount_amount, // ส่วนลดบาทต่อรายการ
              discountPercent: item.discount_percent == null ? 0 : item.discount_percent, // ส่วนลดเปอร์เซ็นต์ต่อรายการ
              exp: formattedDateExp, // วันที่หมดอายุ
              signature: "", // ลายเซ็นต์
              note: "", // หมายเหตุ
            };
          });

            // เตรียมข้อมูลสำหรับ export ลงไฟล์ Excel
            this.jsonExcel = [];

            // เพิ่มข้อมูลเริ่มต้นลงใน Excel
            this.jsonExcel.push([this.storeDetail.store_name]);
            // ดึงชื่อเดือนจาก month_arr ที่ตรงกับ selected_month_member
            let selectedMonthName = this.month_arr.find(month => month.month_number === this.selected_month_member)?.month_name;
            this.jsonExcel.push(["บัญชีซื้อ (แบบ ข.ย.9) ประจำเดือน " + selectedMonthName + ' ' + this.selected_year_member]);

            this.jsonExcel.push([]);

            this.jsonExcel.push([
              "ลำดับ",
              "เอกสารวันที่",
              "รับจาก",
              "รายการ",
              "เลข lot no.",
              "จำนวน",
              "หน่วย",
              "ส่วนลด (บาท)",
              "ส่วนลด (%)",
              "exp.",
              "ลายเซ็นต์ผู้ปฏิบัติการ",
              "หมายเหตุ",
            ]);

            // ยัดข้อมูลจาก data_excel ลง jsonExcel
            this.data_excel.forEach((el) => {
              this.jsonExcel.push([
                el.no,
                el.date,
                el.loca,
                el.description,
                el.lotNo,
                el.amount,
                el.unit,
                el.discountAmount,
                el.discountPercent,
                el.exp,
                el.signature,
                el.note,
              ]);
            });

            // การสร้างไฟล์ Excel
            const dataWS = XLSX.utils.aoa_to_sheet(this.jsonExcel);
            const ws_name = "Sheet1";
            const wscols = [
              { wch: 5 },
              { wch: 12 },
              { wch: 15 },
              { wch: 50 },
              { wch: 15 },
              { wch: 8 },
              { wch: 10 },
              { wch: 14 },
              { wch: 12 },
              { wch: 15 },
              { wch: 20 },
              { wch: 25 },
            ];
            const wb = XLSX.utils.book_new();
            dataWS["!cols"] = wscols;
            XLSX.utils.book_append_sheet(wb, dataWS, ws_name);

            // การใส่สไตล์ในไฟล์ Excel
            dataWS["!merges"] = [
              { s: { r: 0, c: 0 }, e: { r: 0, c: 11 } },
              { s: { r: 1, c: 0 }, e: { r: 1, c: 11 } },
            ];
            dataWS["A1"].s = {
              alignment: { vertical: "center", horizontal: "center" },
              font: { bold: true, sz: 14 },
            };
            dataWS["A2"].s = {
              alignment: { vertical: "center", horizontal: "center" },
              font: { bold: true, sz: 14 },
            };

            const range = XLSX.utils.decode_range(dataWS["!ref"]);
            for (let row = 3; row <= range.e.r; row++) {
              for (let col = range.s.c; col <= range.e.c; col++) {
                const cell_address = { c: col, r: row };
                const cell_ref = XLSX.utils.encode_cell(cell_address);
                if (!dataWS[cell_ref]) continue;
                dataWS[cell_ref].s = {
                  border: {
                    top: { style: "thin", color: { rgb: "000000" } },
                    left: { style: "thin", color: { rgb: "000000" } },
                    bottom: { style: "thin", color: { rgb: "000000" } },
                    right: { style: "thin", color: { rgb: "000000" } },
                  },
                  alignment: { vertical: "center", horizontal: "center" },
                };
                if (col === 3 && row > 3) {
                  dataWS[cell_ref].s.alignment.horizontal = "left";
                }
              }
            }

            XLSX.writeFile(wb, "history_inventory_" + this.date_universal + ".xlsx");
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },


    dateExport() {
      const today = new Date();
      let month = today.getMonth() + 1;
      let date = today.getDate();
      const result_date = date + "_" + month + "_" + (today.getFullYear() + 543);
      return result_date;
    },
  },
  watch: {
    selected_year_member(newVal) {
      this.month_function(newVal); // โหลดตัวเลือกเดือนใหม่เมื่อปีถูกเปลี่ยน
    },
  },
  mounted() {
    this.getShow_api();
    this.getInventory();
    this.year_function(); // โหลดตัวเลือกปีเมื่อหน้าพร้อมใช้งาน
    this.month_function(this.selected_year_member); // โหลดตัวเลือกเดือนตามปีที่เลือก
  },
};
</script>


<style scoped>
.input-radius {
  border-radius: 10px;
}

.header_content {
  font-weight: 600;
  font-size: 20px;
  color: #616a6b;
}

.btn_add_data {
  width: 100%;
}
.export-file {
  width: 150px;
}
</style>
